import GraphTabs from 'graph-tabs';

export function stockTabs() {
  const tabs = new GraphTabs('stock-tabs');
}
